const ENStepsOccurrences = {
	"Alterar etapa padrão de ocorrência": "Change standard occurrence step",
	"Deseja realmente excluir a etapa padrão de ocorrência": "Do you really want to delete the standard occurrence step",
	"Etapas Padrões de Ocorrências": "Standard occurrence steps",
	"Etapas padrões de ocorrências": "Standard occurrence steps",
	"Erro ao adicionar etapa padrão de ocorrência": "Error adding standard occurrence step",
	"Erro ao alterar etapa padrão de ocorrência": "Error on changing standard occurrence step",
	"Erro ao excluir etapa padrão de ocorrência": "Error on deleting standard occurrence step",
	"Erro ao reordenar etapas padrões": "Error on reordering standard occurrence steps",
	"Etapa padrão de ocorrência adicionada com sucesso": "Standard occurrence step successfully added",
	"Etapa padrão de ocorrência alterada com sucesso": "Standard occurrence step successfully changed",
	"Etapa padrão de ocorência excluída com sucesso": "Standard occurrence step successfully deleted",
	"Etapas padrões redordenadas com sucesso": "Standard occurrence steps successfully ordered",	
	"Exclusão de etapa padrão de ocorrência": "Delete standard occurrence step",
	"Inserção de etapa padrão de ocorrência": "Insert standard occurrence step",
	"Nova etapa padrão de ocorrência": "New standard occurrence step",
	"Ordenar etapas padrão de ocorrência": "Order standard occurrence steps",
	"Verificação da Eficácia": "Verification of effectiveness",
	"Verificação de eficâcia": "Verification of effectiveness",
	"Reordenar etapas padrão": "Reorder standard occurrence steps"
};

export default ENStepsOccurrences;

